import {
  observable,
  transaction,
  map,
  computed,
  autorun,
  runInAction,
  action
} from 'mobx';

import tools from '../../../../utils/tools';
import QueryApi from '../api/QueryApi';

import { Toast } from 'antd-mobile';
import { object } from 'prop-types';

function setTip(a, b, text) {
  Toast.info(text, 3);
}

export default class PlanItemModel {
  store;
  searchPlan;
  code; // 新增，返回查询数据对象按照此名读取或设置json
  @observable name = null; //  修改，取原来的 EAP_SearchItem_Ext.FieldTitle
  @observable type = null; // 取原来 EAP_SearchItemCtrlInfo_Ext.ControlType
  @observable beginDefault = null;
  @observable endDefault = null;
  @observable beginDefaultText = null;
  @observable endDefaultText = null;
  @observable valueType = 'id';
  @observable isBetween = false; // 是否是区间
  @observable mode = 'single'; // 单选（single）还是多选 （multi）
  @observable modeRange; //  'single', "multi", "range"]  条件类型，是否可以单选、多选或者区间
  @observable match = null; // 匹配模式   exact  , fuzzy  , left  right
  @observable matchRange = null;
  @observable group = null; // 所属分组

  @observable visible = false;
  @observable disabled = false;
  @observable required = false;
  @observable groupDisabled = false; // 分组禁止

  // @observable formatString;
  // @observable precision;
  // @observable maxLength;
  // @observable multiSelect;
  // @observable refShowField;
  // @observable refDataSource;
  // //"EnumName": "",
  // @observable dropDownStyle;
  // @observable allowAdd;
  // @observable allowEdit;
  // @observable refContinuumSelect;
  // @observable refCategoryTree;

  @observable options = {};

  @observable value = null;

  get val() {
    return this.value && this.value.value;
  }

  set val(value) {
    this.setValue({
      value
    });
  }

  get text() {
    return this.value && this.value.text;
  }

  set text(text) {
    this.setValue({
      text,
      value: this.val
    });
  }

  // 组件名称
  @computed get component() {
    let name;
    switch (this.type.toLowerCase()) {
    case 'textbox':
    case 'numtextbox':
      if (this.isBetween || this.mode === 'range') {
        name = 'inputRange';
      } else {
        name = 'inputItem';
      }
      break;
    case 'dateselectdropdown':
      name = 'dateRange';
      break;
    case 'datedropdown':
      if (this.isBetween || this.mode === 'range') {
        name = 'dateRange';
      } else {
        name = 'datePick';
      }
      break;
    case 'checkbox':
    case 'radioboxlist':
      name = 'buttonGroup';
      break;
      // case 'timetextbox':
      //   name = FilterTimeTextBox;
      //   break;
    case 'label':
      name = 'none';
      break;
    case 'textcombobox':
    case 'refcombobox':
    case 'reftextbox':
    case 'combobox':
    case 'multireftextbox':
      name = 'refBox';
      break;
    default:
      console.warn(this.code + ' type ' + this.type + ' not support');
      name = 'none';
      break;
    }
    return name;
  }

  @action async setValue(value, refObject) {
    if (this.component === 'refBox') {
      let refShowField = this.options?this.options.refShowField:'';
      const vs = await Promise.all((this.mode === 'single' ? [value] : value).map(async (it) => {
        if (it) {
          let refValue = it.id;
          if (this.valueType.toLowerCase() === 'id') {
            refValue = it.id || it.ID || it.Id;
          }
          if (this.valueType.toLowerCase() === 'code') {
            refValue = it.code || it.Code;
          }
          if (this.valueType.toLowerCase() === 'name') {
            refValue = it.name || it.Name;
          }
          if (this.valueType.toLowerCase() === 'text') {
            refValue = it.Text || it.Name || it.Code || it.id || it.ID || it.Id || it.Value;
          }

          //处理refShowField为‘code+name’的情况
          let refShowFields = refShowField?refShowField.split('+'):[];
          let texts = [];

          if (refShowField && it.refShowField === undefined && refValue === undefined && !it.$text) {
            let dto = await this.GetDtoByIdAndSelectFields(refObject, it.id || it.ID || it.Id, refShowField);
            texts = (refShowFields&&refShowFields.length>0)?refShowFields.map(item=> {
              let value = typeof dto[item] === 'object' ? dto[item]['Name'] : dto[item];
              let reg = /(\d{4}-\d{2}-\d{2})\T\d{2}:\d{2}:\d{2}/;
              if (reg.test(value)) {
                value = value.match(reg)[1];
              }
              return value;
            }):[];
            refValue = it.id || it.ID || it.Id;
          } else if (it.$text) {
            refValue = it[Object.keys(it)[1]];
          } else {
            texts = (refShowFields&&refShowFields.length>0)?refShowFields.map(item=>it[item]):[];
          }

          return {
            text: (texts&&texts.length>0)?texts.join('/'):(it.$text || it.Name || refValue),
            value: refValue
          }
        } else {
          return {
            text: '',
            value: ''
          }
        }
      }));
      runInAction(() => {
        if (this.mode === 'single') {
          this.value = vs[0];
        } else {
          this.value = vs;
        }
      })
    } else {
      if (this.mode === 'single') {
        this.value.text = value.text;
        this.value.value = value.value;
      } else {
        this.value = value.map(it => ({
          text: it.text,
          value: it.value
        }));
      }
    }
  }

  @action async GetDtoByIdAndSelectFields(dtoName, id, selectFields) {
    if (!id) {
      return {};
    }
    let dto = await QueryApi.GetDtoByIdAndSelectFields({
      dtoName,
      id,
      selectFields
    })
    console.log('dto => ', dto);
    return dto;
  }

  // 取消前端sql拼接，改成后端拼接sql
  //"DropDownWhere": "InventoryDTO.Disabled = 0 and (InventoryDTO.IsMadeSelf = 1 or InventoryDTO.IsMadeRequest = 1)",
  //"RefWhere": ":InventoryDTO.Disabled = 0 and (InventoryDTO.IsMadeSelf = 1 or InventoryDTO.IsMadeRequest = 1)",

  constructor(store,
    searchPlan,
    code,
    name,
    type,
    mode,
    isBetween,
    modeRange,
    match,
    matchRange,
    group,
    beginDefault,
    endDefault,
    beginDefaultText,
    endDefaultText,
    valueType,
    visible,
    disabled,
    required,
    groupDisabled,
    options,
    // formatString,
    // precision,
    // maxLength,
    // multiSelect,
    // refShowField,
    // refDataSource,
    // dropDownStyle,
    // allowAdd,
    // allowEdit,
    // refContinuumSelect,
    // refCategoryTree
    value
  ) {
    this.store = store;
    this.searchPlan = searchPlan;
    this.code = code;
    this.name = name;
    this.type = type;
    this.mode = mode;
    this.isBetween = isBetween;
    this.modeRange = modeRange || [];
    this.match = match;
    this.matchRange = matchRange || [];
    this.group = group;
    this.beginDefault = beginDefault;
    this.endDefault = endDefault;
    this.beginDefaultText = beginDefaultText;
    this.endDefaultText = endDefaultText;
    this.valueType = valueType;
    this.visible = visible;
    this.disabled = disabled;
    this.required = required;
    this.groupDisabled = groupDisabled;
    this.options = options;
    // this.formatString = formatString;
    // this.precision = precision;
    // this.maxLength = maxLength;
    // this.multiSelect = multiSelect;
    // this.refShowField = refShowField;
    // this.refDataSource = refDataSource;
    // this.dropDownStyle = dropDownStyle;
    // this.allowAdd = allowAdd;
    // this.allowEdit = allowEdit;
    // this.refContinuumSelect = refContinuumSelect;
    // this.refCategoryTree = refCategoryTree;

    if (mode === 'single') {
      this.value = value || {
        text: beginDefaultText,
        value: beginDefault
      };
    } else if (mode === 'range') {
      this.value = value || [{
        text: beginDefaultText,
        value: beginDefault
      }, {
        text: endDefaultText,
        value: endDefault
      }];
    } else {
      this.value = value || [];
    }
  }

  parseTypeValue(val) {
    if (!val) {
      return val;
    }
    switch (this.type) {
    case 'numtextbox':
      return parseFloat(val);
      break;
    default:
      return val;
    }
  }

  validate() {
    const data = this.value;
    if (this.required) {
      if (this.mode == 'range') {
        if (!data || !(data.length > 1) || !data[0].value || !data[1].value) {
          setTip(true, 'error', (this.name + '不能为空，请输入'));
          return false;
        }
      } else if (this.mode == 'single') {
        switch (this.type.toLowerCase()) {
        case 'checkbox':
          break;
        case 'dateselectdropdown':
        case 'numtextbox':
        case 'refcombobox':
        case 'textbox':
        case 'multireftextbox':
          // RadioBoxList
          // TextComboBox
          // Label
          // DateDropDown
          // TimeTextBox
          // RefTextBox
          // ComboBox
        default:
          if (!data || !data.value) {
            setTip(true, 'error', (this.name + '不能为空，请输入'));
            return false;
          }
        }
      } else if (this.mode == 'multi') {
        if (!data || data.length <= 0) {
          setTip(true, 'error', (this.name + '不能为空，请输入'));
          return false;
        }
      }
    }
    if (this.mode == 'range') {
      if (data && (data.length == 2)) {
        let v1 = '';
        if(data[0] &&!tools.isNull(data[0].value)){
          v1 = this.parseTypeValue(data[0] && data[0].value);
        }
        let v2 = '';
        if(data[1] && !tools.isNull(data[1].value)){
          v2 = this.parseTypeValue(data[1] && data[1].value);
        }
        console.log('v========v1',v1);
        console.log('v========v2',v2);
        // 这里注意“0”是需要比较大小的
        if (!tools.isNull(v1) && !tools.isNull(v2) && v2 < v1) {
          setTip(true, 'error', (this.name + '结束值不能小于开始值'));
          return false;
        }
      }
    }
    switch (this.type.toLowerCase()) {
    case 'dateselectdropdown':
      {
        if (data && data.length > 1 && data[1] && data[0] && data[1].value && data[0].value) {
          if (data[1].value < data[0].value) {
            setTip(true, 'error', (this.name + '结束值不能小于开始值'));
            return false;
          }
        }
        break;
      }
    case 'numtextbox':
    case 'refcombobox':
    case 'checkbox':
    case 'textbox':
    case 'multireftextbox':
      // RadioBoxList
      // TextComboBox
      // Label
      // DateDropDown
      // TimeTextBox
      // RefTextBox
      // ComboBox
    default:
      break;
    }
    return true;
  }

  toJS() {
    return {
      code: this.code,
      name: this.name,
      type: this.type,
      mode: this.mode,
      isBetween: this.isBetween,
      modeRange: this.modeRange,
      match: this.match,
      matchRange: this.matchRange,
      group: this.group,
      beginDefault: this.beginDefault,
      endDefault: this.endDefault,
      beginDefaultText: this.beginDefaultText,
      endDefaultText: this.endDefaultText,
      valueType: this.valueType,
      visible: this.visible,
      disabled: this.disabled,
      required: this.required,
      groupDisabled: this.groupDisabled,
      options: this.options
      // formatString: this.formatString,
      // precision: this.precision,
      // maxLength: this.maxLength,
      // multiSelect: this.multiSelect,
      // refShowField: this.refShowField,
      // refDataSource: this.refDataSource,
      // dropDownStyle: this.dropDownStyle,
      // allowAdd: this.allowAdd,
      // allowEdit: this.allowEdit,
      // refContinuumSelect: this.refContinuumSelect,
      // refCategoryTree: this.refCategoryTree,
    };
  }

  static fromJS(store, searchPlan, {
    name,
    code,
    type,
    mode,
    isBetween,
    modeRange,
    match,
    group,
    matchRange,
    beginDefault,
    endDefault,
    beginDefaultText,
    endDefaultText,
    valueType,
    visible,
    disabled,
    required,
    groupDisabled,
    options
    // formatString,
    // precision,
    // maxLength,
    // multiSelect,
    // refShowField,
    // refDataSource,
    // dropDownStyle,
    // allowAdd,
    // allowEdit,
    // refContinuumSelect,
    // refCategoryTree
  }, value) {
    return new PlanItemModel(store, searchPlan, code, name, type, mode,
      isBetween, modeRange, match, matchRange, group, beginDefault, endDefault, beginDefaultText, endDefaultText, valueType, visible, disabled, required, groupDisabled,
      options, value);
  }
}
